export default {
    name: 'preceding',
    serverName: '​/api/v1/normative_calculator/preceding_culture/',
    apiUrl: '/api/v1/normative_calculator/preceding_culture/'
};
